<template>
  <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark" id="accordionSidebar">
    <router-link class="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
      <img src="@/assets/logo.png" alt="atrio" />
    </router-link>

    <div class="sidebar-heading">Modulos</div>

    <li class="nav-item">
      <a class="nav-link" href="#" aria-expanded="true" aria-controls="sales">
        <i class="fas fa-hand-holding-usd"></i>
        <router-link style="color: #fff" to="/nota">Notas Fiscais</router-link>
      </a>
    </li>

    <li class="nav-item">
      <router-link class="nav-link" to="/contas">
        <i class="fas fa-fw fa-user"></i>
        <router-link style="color: #fff" to="/usuario">Usuários</router-link>
      </router-link>
    </li>

    <hr class="sidebar-divider d-none d-md-block" />
  </ul>
</template>

<script>
export default {
  mounted() {},
};
</script>

<style lang="scss">
ul {
  li {
    p {
      margin: 0;
    }
  }
}
</style>
